import { z } from 'zod'
import { ALLOWED_MARKETS } from '../../../../../../shared/domain/Market'
import { BannerTypeValidation } from '../../../../../domain/BannerType'
import { I18nTextValidation } from '../../../../../../_kernel/I18nText'
import { UrlValidation } from '../../../../../../_kernel/Url'
import { ColorValidation } from '../../../../../../_kernel/Color'
import { BannerSubtypeValidation } from '../../../../../../marketing/domain/BannerSubtype'
// import { ALLOWED_BANNER_SUBTYPES_BY_TYPE } from '../../../../../../marketing/domain/Banner'

export const GETBannerInformationResponse = z.object({
  banners: z.array(
    z.object({
      type: BannerTypeValidation.shape.value,
      subtype: BannerSubtypeValidation.shape.value.optional(),
      content: z.record(
        z.enum(ALLOWED_MARKETS).or(z.literal('all')),
        z.object({
          title: z.array(I18nTextValidation.shape.value),
          description: I18nTextValidation.shape.value.optional(),
          url: UrlValidation.shape.value.optional(),
          ctaText: I18nTextValidation.shape.value.optional(),
          bgColor: ColorValidation.shape.value.optional(),
          titleColor: ColorValidation.shape.value.optional(),
          descriptionColor: ColorValidation.shape.value.optional(),
          image: z
            .object({
              srcSet: UrlValidation.shape.value.array(),
              alt: I18nTextValidation.shape.value,
            })
            .optional(),
        })
      ),
    })
    // .refine(
    //   data => {
    //     if (!data.subtype) return true
    //     const validSubtypes = ALLOWED_BANNER_SUBTYPES_BY_TYPE[data.type]
    //     return validSubtypes?.includes(data.subtype as any) ?? false // eslint-disable-line @typescript-eslint/no-explicit-any
    //   },
    //   {
    //     message: 'Invalid subtype for the specified banner type',
    //     path: ['subtype'],
    //   }
    // )
  ),
})

export type GETBannerInformationResponseType = z.infer<typeof GETBannerInformationResponse>

export const GETBannerInformationResponseLenient = z.object({
  banners: z.array(z.any()),
})

export type GETBannerInformationResponseLenient = z.infer<
  typeof GETBannerInformationResponseLenient
>
